<template>
	<div class="row">
		<div class="col-12 col-lg-4 order-2 order-md-0" v-if="!isMobile">
			<user-info></user-info>
		</div>
		<div class="col-12 col-lg-8">
			<div class="block block--visible block--nopad">
				<div class="block__content">
               <div class="row">
                  <div class="col-12">
                     <div class="account__block__title">{{ t('user.page.table.bets.title') }}</div>
                  </div>
               </div>
			   <!--
               <div class="row" >
                  <div class="col-12 d-flex">
                     <router-link class="btn btn-link btn-sm" :to="{name: 'UserBets'}" :class="{ 'active': $route.name.includes('UserBets')}">{{t('user.page.table.bets.type.horse')}}</router-link>
                     <router-link class="btn btn-link btn-sm" :to="{name: 'UserSportBets'}" :class="{ 'active': $route.name.includes('UserSportBets')}">{{t('user.page.table.bets.type.sport')}}</router-link>
                  </div>
               </div>-->
               <router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import UserInfo from '@/components/user/modules/info';

	export default {
		name: 'UserBets',
		components: {
			UserInfo,

		},
		data() {
			return {

			}
		},
		computed:{

		},

	}
</script>
